import React from 'react';
import styled from 'styled-components';
import { VirtualVisitIcon } from '@zocdoc-frontend-common/assets-icons';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

/**
 * @param {string} className
 * @param {string} professionalName
 * @returns {JSX.Element}
 * @constructor
 */
export const VideoVisitBannerOneLineView = ({
    className,
    professionalName,
}) => {
    const bannerText = `Look out for an email from ${professionalName} with a link to join your video visit`;
    return (
        <Banner className={className} data-test="video-visit-banner">
            <Content>
                <StyledVirtualVisitIcon />
                <p>{bannerText}</p>
            </Content>
        </Banner>
    );
};

VideoVisitBannerOneLineView.defaultProps = {
    professionalName: 'your doctor',
};

const Banner = styled.div`
    background: #e9dcf6;
    display: table;
    padding: 12px;
    font-family: ${FontFamily.SharpSansMedium};
    font-size: 24px;
    line-height: 24px;
    p {
        font-family: ${FontFamily.SharpSansMedium};
        font-size: 13px;
        line-height: 1em;
        margin: auto 0;
        padding-left: 8px;
    }
`;

const Content = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledVirtualVisitIcon = styled(VirtualVisitIcon)`
    min-width: 1em;
`;
